import styled from 'vue-styled-components'
import colors from '@/components/kit/theme'

// use <color-section :background="'white'" :background-opacity="'30'" :border="'black'" :text="'black'"></color-section>

const componentProps = {
  background: String,
  backgroundOpacity: Number,
  border: String,
  borderRadius: String,
  text: String
}

const ColorSection = styled('section', componentProps)`
  background-color: ${(props) =>
    props.backgroundOpacity == null
      ? colors.knownColor(props.background)
      : colors.knownColorWithOpacity(
          props.background,
          props.backgroundOpacity
        )};
  border: ${(props) => (props.border == null ? '' : '1px solid')}
    ${(props) => (props.border == null ? '' : colors.knownColor(props.border))};
  border-color: ${(props) => colors.knownColor(props.border)};
  color: ${(props) => colors.knownColor(props.text)};
  border-radius: ${(props) => props.borderRadius};
`

export default {
  props: {
    background: String,
    backgroundOpacity: Number,
    border: String,
    borderRadius: String,
    text: String
  },
  render(h) {
    return (
      <ColorSection
        class="color"
        background={this.background}
        background-opacity={this.backgroundOpacity}
        border={this.border}
        border-radius={this.borderRadius}
        text={this.text}
      >
        {this.$slots.default}
      </ColorSection>
    )
  }
}
